// extracted by mini-css-extract-plugin
export default {"root":"EditForm_root__bYuIR","form":"EditForm_form__dLwsn","after":"EditForm_after__Av4Zu"};